<!-- <div *ngIf="isComponentReadyToStart"> -->
    <!-- Rebate Request - Measurement Committee / Economic Committee - Confirm Ship Passing -->
    <div *ngIf="!isRequestSucceeded">
        <!-- Form Title -->
        <h2 class="sectionTitle">{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.FORM_TITLE" | translate}}</h2>
        <!-- <div *ngIf="formMode == 2" class="bs-callout bs-callout-info"> 
            <p>{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.CONFIRMED_MESSAGE" | translate}}</p>
        </div> -->
        <!-- Rebate Request - Display Mode -->
        <app-circular-request #circularsRequest (rebateRequestLoadedFlag)="onCircularsRequestLoadedFlag($event)"></app-circular-request>
        <div [class.read-only-content]="formMode == 2">
            <form name="form" #f="ngForm">
                <div class="form-container">
                    <div class="form-section">
                        <h4 class="section-title">{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.CONFIRM_SHIP_PASSING_SECTION" | translate}}</h4>
                        <!-- Ship Passed -->
                        <div class="form-group">
                             <label>{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.SHIP_PASSED" | translate}}</label>
                            <span *ngIf="formMode == 1" class="red"> *</span>
                            <div class="custom-checkbox">
                                <input [disabled]="formMode == 2" type="checkbox" [(ngModel)]="circularsRequest.rebateRequestLoaded.IsShipPassed" name="ShipPassed" id="chkShipPassed" value="false" (change)="onShipPassedChange()" required #isShipPassed="ngModel">
                                <label for="chkShipPassed">{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.SHIP_PASSED" | translate}}</label>                                                
                            </div>
                        </div>
                    </div>
                    <div *ngIf="circularsRequest.rebateRequestLoaded.IsShipPassed" class="form-section">
                        <!-- Voyage Actual Option -->
                        <div>
                            <label>{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.ACTUAL_OPTION_SECTION" | translate}}</label>
                            <span *ngIf="formMode == 1" class="red"> *</span>
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-services">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Option</th>
                                            <th><span>Origin Region</span></th>
                                            <th><span>Destination Region</span></th>
                                        </tr>
                                    </thead>
                                <!-- <div class="custom-Radio">
                                    <input [disabled]="formMode == 2" type="radio" [(ngModel)]="previouslySelectedOption.Id" id="rbtnCircularsRequestOption_{{circularsRequestOption?.Id}}" name="CircularsRequestOptions_{{circularsRequestOption?.Id}}" value="{{circularsRequestOption?.Id}}" (change)="onOptionSelect(i)" />
                                    <label for="rbtnCircularsRequestOption_{{circularsRequestOption?.Id}}">
                                        {{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.OPTION" | translate}} {{i + 1}} ({{circularsRequest?.OriginsArr[i].Text}}) - ({{circularsRequest?.distinationArr[i].Text}})
                                    </label> -->
                                    <tbody>
                                        <tr *ngFor="let circularsRequestOption of circularsRequestOptions; let i = index;">
                                            <ng-container>
                                                <td><div><input [disabled]="formMode == 2" type="radio" [(ngModel)]="previouslySelectedOption.Id" id="rbtnCircularsRequestOption_{{circularsRequestOption?.Id}}" name="CircularsRequestOptions_{{circularsRequestOption?.Id}}" value="{{circularsRequestOption?.Id}}" (change)="onOptionSelect(i)" /></div>
                                                </td>
                                                <td>{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.OPTION" | translate}} {{i + 1}}</td>
                                                <td>{{circularsRequest?.OriginsArr[i].Text}}
                                                </td>
                                                <td>{{circularsRequest?.distinationArr[i].Text}}
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="isOptionSelectionNotValid" class="red">
                                <span>{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.Please_choose_either_options_to_proceed" | translate}}</span>
                            </div>
                        </div>

                        <div *ngIf="isOptionDetailsEnabled && circularsRequest.rebateRequestLoaded.IsShipPassed" [class.read-only-content]="formMode == 1" class="form-section">
                            <h4 class="section-title">{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.CONFIRMED_REBATE_PERCENTAGE" | translate}}</h4>
                            <!-- Rebate Percentage -->
                            <div class="form-group">
                                <label for="txtRebatePercentage">{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.REBATE_PERCENTAGE" | translate}}</label>
                                <div class="input-group">
                                    <label name="SuggestedRebate" id="lblSuggestedRebate" class="form-control">{{optionPercentage}}</label>
                                    <span class="input-group-addon">%</span>
                                </div>
                                <div *ngIf="!selectedCircularsOption.IsGranted" class="red">
                                    <span>{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.REBATE_NOT_GRANTED" | translate}}</span>
                                </div>
                                <!-- <div *ngIf="!selectedCircularsOption.IsGranted" class="red">
                                    <span>{{selectedCircularsOption.Notes}}</span>
                                </div> -->
                            </div>

                        </div>
                    </div>
                    <div *ngIf="circularsRequest.rebateRequestLoaded.IsShipPassed" class="form-section">
                        <!-- Passing Date -->
                        <div class="form-group">
                            <label for="dpPassingDate">{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.PASSING_DATE" | translate}}</label>
                            <span *ngIf="formMode == 1" class="red"> *</span>
                            <input [disabled]="formMode == 2" [(ngModel)]="circularsRequest.rebateRequestLoaded.PassingDate" #passingDateDatepicker="bsDatepicker" bsDatepicker [minDate]='null' [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour, maxDate: passingDateMaxDate}" id="dpPassingDate" class="form-control" name="PassingDate" (ngModelChange)="onPassingDateChange()" />
                            <timepicker [disabled]="formMode == 2" id="tmPassingDate" [(ngModel)]="circularsRequest.rebateRequestLoaded.PassingDate" name="PassingDate" [hourStep]="1" [minuteStep]="1"></timepicker>
                            <div *ngIf="isPassingDateNotValid" class="red">
                                <span>{{"FRONT_USER.This_Field_Is_Required" | translate}}</span>
                            </div>
                        </div>

                    </div>   
                </div>
                <div *ngIf="formMode == 1" class="form-group">
                    <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="isFormSubmitted = true; f.form.valid && submit()">{{"FRONT_USER.SUBMIT" | translate}}</button>
                    <!-- <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button> -->
                </div>
            </form>
        </div>
    </div>
    <!-- Confirmation -->
    <div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
        <div class="alignC">
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g>
                    <g>
                        <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                    </g>
                </g>
            </svg>
            <p>{{"ADMIN_USER.CIRCULARS.CONFIRM_SHIP_PASSING.You_have_chnaged_the_status_for_this_Rebate_Request" | translate}}</p>
            <p>{{"FRONT_USER.GOBACK" | translate}} <a routerLink="/CircularsReport">{{"ADMIN_USER.CIRCULARS.CIRCULARS_REPORT" | translate}}</a></p>
        </div>
    </div>
    <!-- Warning -->
    <div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
        <div class="alignC">
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g>
                    <g>
                        <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                    </g>
                </g>
            </svg>
            <p>{{"FRONT_USER.ERRORS_MESSAGES.TaskCompletedByAnotherUser" | translate}}</p>
            <p>{{"FRONT_USER.GOBACK" | translate}} <a routerLink="/CircularsReport">{{"ADMIN_USER.CIRCULARS.CIRCULARS_REPORT" | translate}}</a></p>
        </div>
    </div>
    <!-- Error -->
    <div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
        <div class="alignC">
            <i class="icon-error"></i>
            <p>Something went wrong, Please contact System Administrator</p>
            <hr>
            <p>{{"FRONT_USER.GOBACK" | translate}} <a routerLink="/workspace">Workspace</a></p>
        </div>
    </div>
<!-- </div> -->